import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../UI';

interface UnsavedChangesModalProps {
  // Promise-returning so Button can disable itself while the teardown runs — a
  // second click would release the lock and resume the navigation twice.
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

export const UnsavedChangesModal = ({ onConfirm, onCancel }: UnsavedChangesModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      title={t('leave-unsaved-title')}
      message={t('leave-unsaved-message')}
      warning={t('leave-unsaved-warning')}
      cancelLabel={t('leave-unsaved-cancel')}
      confirmLabel={t('leave-unsaved-confirm')}
      onConfirm={onConfirm}
      onClose={onCancel}
    />
  );
};
